import { render, staticRenderFns } from "./AutoInfracaoGoPoligono.vue?vue&type=template&id=66b8c7bc&lang=pug"
import script from "./AutoInfracaoGoPoligono.vue?vue&type=script&lang=js"
export * from "./AutoInfracaoGoPoligono.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports